import {
  NOT_FOUND,
  UNAUTHORIZED,
  UNPROCESSABLE_ENTITY,
} from "@/app/constants/httpStatuses";
import { Error } from "@/app/types/error-types";

type CheckInError =
  | {
      kind:
        | "networkError"
        | "unauthorized"
        | "orderNotFound"
        | "alreadyCheckedIn"
        | "unknown";
    }
  | { kind: "invalid"; serverMessages: string[] };

type ArrivalApiError = Error & { httpStatus: number };

const ALREADY_CHECKED_IN_MESSAGES = [
  "Already checked-in",
  "تم تسجيل وصول العميل مسبقاً",
];

const isAlreadyCheckedIn = ({ message, errors }: Error): boolean =>
  [message, ...(errors || [])].some(
    (text) => !!text && ALREADY_CHECKED_IN_MESSAGES.includes(text.trim()),
  );

const toCheckInError = (apiError: ArrivalApiError): CheckInError => {
  switch (apiError.httpStatus) {
    case UNAUTHORIZED:
      return { kind: "unauthorized" };
    case NOT_FOUND:
      return { kind: "orderNotFound" };
    case UNPROCESSABLE_ENTITY: {
      if (isAlreadyCheckedIn(apiError)) {
        return { kind: "alreadyCheckedIn" };
      }
      const serverMessages = apiError.errors?.length
        ? apiError.errors
        : [apiError.message].filter(Boolean);
      return { kind: "invalid", serverMessages };
    }
    default:
      return { kind: "unknown" };
  }
};

const canRetry = ({ kind }: CheckInError): boolean =>
  kind !== "alreadyCheckedIn" && kind !== "unauthorized";

const getCheckInErrorMessage = (
  error: CheckInError,
  t: (key: string) => string,
): string => {
  if (error.kind === "invalid") {
    return (
      error.serverMessages.join(", ") ||
      t("tpos.pickupDriveThru.errors.validationFailed")
    );
  }
  return t(`tpos.pickupDriveThru.errors.${error.kind}`);
};

export type { CheckInError };
export { toCheckInError, canRetry, getCheckInErrorMessage };
